import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

import { ControlWrapperComponent } from '../control-wrapper/control-wrapper.component';
import { ControlHasRequiredPipe } from '../pipes/control-has-required.pipe';
import { OfficeToolsValidators } from '../../validators';
import { MASK_CONFIG } from './constants/mask.constants';
import { MaskedInputDirective } from './directives/masked-input-base.directive';
import { InputType, InputTypeEnum } from './models/input-type.models';
import { InputPercentComponent } from './input-percent/input-percent.component';

@Component({
  selector: 'app-input',
  templateUrl: 'input.component.html',
  styleUrls: ['input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ControlWrapperComponent, ReactiveFormsModule, ControlHasRequiredPipe, NgxMaskDirective, CommonModule, InputPercentComponent],
  providers: [provideNgxMask(MASK_CONFIG)],
})
export class InputComponent extends MaskedInputDirective implements OnInit {
  @Input() override type: InputType = 'text';

  readonly InputTypeEnum = InputTypeEnum;

  ngOnInit(): void {
    super.ngOnInit();
    this.addValidatorsByType();
  }

  public onBlur(event: MouseEvent): void {
    super.onBlur(event);

    if (this.type === InputTypeEnum.number) {
      this.clearupNotNumericValue();
    }
  }

  private clearupNotNumericValue(): void {
    if (this.control.value === '' || isNaN(this.control.value)) {
      this.control.setValue(null);
    }
  }

  private addValidatorsByType(): void {
    switch (this.type) {
      case InputTypeEnum.number:
        this.control.addValidators(OfficeToolsValidators.numericRange(this.officeField));
        break;
      default:
        break;
    }
  }
}
